var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7142 15.3655V16.5883C29.7126 19.4546 28.7844 22.2435 27.0683 24.5392C25.3521 26.8348 22.9398 28.5143 20.1912 29.3269C17.4426 30.1396 14.5049 30.042 11.8163 29.0487C9.12764 28.0554 6.83213 26.2196 5.27209 23.8151C3.71206 21.4106 2.97108 18.5662 3.15967 15.7062C3.34826 12.8462 4.45631 10.1237 6.31857 7.94486C8.18083 5.76602 10.6975 4.24753 13.4933 3.61586C16.2891 2.9842 19.2141 3.27319 21.8322 4.43975",
    stroke: "#16AC37",
    strokeWidth: 1.77222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7147 5.95703L16.423 19.262L12.4355 15.2745",
    stroke: "#16AC37",
    strokeWidth: 1.77222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.dc8be9d13f8b12383c752c1a5635b141.svg";
export { ForwardRef as ReactComponent };